// eslint-disable-next-line import/prefer-default-export
export const TAGS_ENUM = Object.freeze(['Moving', 'Eating', 'Enrichment', 'Playing', 'Breeding', 'Resting']);
